import styled from 'styled-components';
import { Tag } from 'antd';
import { METRIC_FILTER_COLOR } from '@components/metrics-panel-hz/utils/metricFilterSeriesOption';
import { EllipsisTooltip } from '@components/common';

export const Wrapper = styled.div`
  padding: 3px;
  margin: 5px;
  color: #333;
  display: flex;
  background-color: #ECECEC;
  margin-bottom: 0px;
  position: relative;
  padding-left: 10px;
  .anticon.anticon-close {
    vertical-align: 0.125em;
  }
`;

export const VerticalBar = styled.span`
  position: absolute;
  width: 0.3rem;
  top: 0;
  left: 0;
  bottom: 0;
  background: ${METRIC_FILTER_COLOR};
  z-index: 1;
`;

export const StyledTag = styled(Tag)`
  position: relative;
  font-size: 14px;
  padding: 5px 8px;
  background-color: white;
  align-self: center;
`;

export const ClearButton = styled.div`
  width: 20px;
  height: 100%;
  line-height: 1;
  justify-content: center;
  display: flex;
  align-items: baseline;
  font-size: 1em;
  color: #333;
  div {
    cursor: pointer;
  }
`;

export const StyledEllipsisTooltip = styled(EllipsisTooltip)`
  max-width: 250px;
  width: auto;
  line-height: 1;
`;
